import { Component } from 'react'
import Select from 'react-select-plus'
import { Icon } from '@driftt/tide-core-legacy'
import { DriftActivityType, EmptyActivity } from './constants'
import { values, isNil, without, uniq, isEmpty, complement, equals } from 'ramda'
import { searchForMarketoActivity } from 'app/modules/integrations/api'

const SEARCH_DELAY_IN_MS = 300

const DriftActivityText = {
  [DriftActivityType.SYNC_CONVERSATIONS]: 'New Drift Conversation',
  [DriftActivityType.SYNC_MEETINGS]: 'New Drift Meeting',
  [DriftActivityType.SYNC_CQL_SCORE]: 'New Drift CQL Score'
}

const isNonEmptyActivityType = activityType =>
  complement(equals)(activityType, EmptyActivity.activityType)

const resolveVisibleDriftActivityTypes = (activityType, mappedActivityTypes) => uniq([
  ...without(mappedActivityTypes, values(DriftActivityType)),
  activityType
])

const activitySearchResultToSelectItem = result => ({
  value: result.id,
  label: result.name
})


class MarketoActivityOption extends Component {

  state = {
    activitySearchResults: [],
    canDisplayNoResultsMessage: false
  }

  onMarketoInputChange = (value) => {
    const handleSearchResults = (results) =>
      this.setState({
        activitySearchResults: results,
        canDisplayNoResultsMessage: true
      })

    searchForMarketoActivity(value)
      .then(handleSearchResults)
  }

  onMarketoInputChangeDebounced = _.debounce(this.onMarketoInputChange, SEARCH_DELAY_IN_MS)

  onMarketoInputSelected = ({ value, label }) => {
    const { updateActivities, activity, activityIndex } = this.props
    const mappedActivity = {
      marketoId: value,
      marketoName: label
    }

    updateActivities({ activityIndex, mappedActivity })
  }

  onDriftInputSelected = ({ value }) => {
    const { updateActivities, activity, activityIndex } = this.props
    const mappedActivity = {
      activityType: value
    }

    updateActivities({ activityIndex, mappedActivity })
  }

  deleteActivity = () => {
    const { activityIndex, deleteActivity, activity } = this.props
    deleteActivity({ activityIndex, mappedActivity: activity })
  }

  resolveDriftSelectItemOptions = () => {
    const { activity, mappedActivities } = this.props
    const mappedActivityTypes = mappedActivities.map(a => a.activityType)
    const visibleDriftActivityTypes = resolveVisibleDriftActivityTypes(activity.activityType, mappedActivityTypes)

    return visibleDriftActivityTypes
      .filter(isNonEmptyActivityType)
      .map(activityType => ({
        value: activityType,
        label: DriftActivityText[activityType]
      }))
  }

  resolveMarketoSelectItemOptions = () => {
    const { activitySearchResults } = this.state
    const { activity } = this.props

    var defaultOptions = []
    if (!isNil(activity.marketoId) && !isNil(activity.marketoName)) {
      defaultOptions = [{
        value: activity.marketoId,
        label: activity.marketoName
      }]
    }

    return isEmpty(activitySearchResults)
      ? defaultOptions
      : activitySearchResults.map(activitySearchResultToSelectItem)
  }

  onMarketoDropdownClosed = () => {
    this.setState({
      activitySearchResults: [],
      canDisplayNoResultsMessage: false
    })
  }

  resolveMarketoNoResultsText = () => {
    const { canDisplayNoResultsMessage, activitySearchResults } = this.state
    return (canDisplayNoResultsMessage && isEmpty(activitySearchResults))
      ? 'No results found'
      : null
  }

  render() {
    const { activity } = this.props

    const driftSelectOptions = {
      multi: false,
      searchable: false,
      autoFocus: false,
      clearable: false,
      value: activity.activityType,
      options: this.resolveDriftSelectItemOptions(),
      onChange: this.onDriftInputSelected
    }

    const marketoSelectOptions = {
      multi: false,
      searchable: true,
      autoFocus: false,
      clearable: false,
      noResultsText: this.resolveMarketoNoResultsText(),
      placeholder: 'Search Marketo activities...',
      value: activity.marketoId,
      options: this.resolveMarketoSelectItemOptions(),
      onInputChange: this.onMarketoInputChangeDebounced,
      onChange: this.onMarketoInputSelected,
      onClose: this.onMarketoDropdownClosed
    }

    return (
      <div className="marketo-activity-mapper-action">
        <Select {...driftSelectOptions} />
        <Select {...marketoSelectOptions} />
        <span onClick={this.deleteActivity}>
          <Icon
            className="close-icon"
            width={15}
            name="close"
          />
        </span>
      </div>
    )
  }
}

export default MarketoActivityOption



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoIntegrationPage/MarketoActivityOption.js